/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ScanFrameBarcodeClassicIcon16Light = forwardRef('ScanFrameBarcodeClassicIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M14 3.5A2.5 2.5 0 0 0 11.5 1H10a.5.5 0 0 0 0 1h1.5A1.5 1.5 0 0 1 13 3.5V5a.5.5 0 0 0 1 0V3.5Z" }),
        React.createElement("path", { d: "M3.5 14A2.5 2.5 0 0 1 1 11.5V10a.5.5 0 0 1 1 0v1.5A1.5 1.5 0 0 0 3.5 13H5a.5.5 0 0 1 0 1H3.5Z" }),
        React.createElement("path", { d: "M11.5 14a2.5 2.5 0 0 0 2.5-2.5V10a.5.5 0 0 0-1 0v1.5a1.5 1.5 0 0 1-1.5 1.5H10a.5.5 0 0 0 0 1h1.5Z" }),
        React.createElement("path", { d: "M3.5 1A2.5 2.5 0 0 0 1 3.5V5a.5.5 0 0 0 1 0V3.5A1.5 1.5 0 0 1 3.5 2H5a.5.5 0 0 0 0-1H3.5Z" }),
        React.createElement("path", { d: "M10.5 4a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0v-6a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { d: "M9 4.5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0v-6Z" }),
        React.createElement("path", { d: "M6.5 4a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0v-6a.5.5 0 0 1 .5-.5Z" }),
        React.createElement("path", { d: "M5 4.5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0v-6Z" })));
});
